jQuery(document).ready(function() {
    jQuery('#rmo_blog_posts').slick({
    dots: false,
    infinite: false,
    speed: 300,
    prevArrow:'<span class="prev_ar"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
    nextArrow:'<span class="next_ar"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>',
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1610,
        settings: {
          slidesToShow: 4 
        }
      },
      {
        breakpoint: 1460,
        settings: {
          slidesToShow: 4,
          centerPadding: '20px'
        }
      },
      {
        breakpoint: 1120,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2
        } 
      },
      {
        breakpoint: 435,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  }); 
    jQuery("#SalesSlider").owlCarousel({
		navigation : true,
		items:1,
		loop:true,
		nav:true,
		navText: [
			'<span aria-hidden="true">&#10094;</span>',
			'<span aria-hidden="true">&#10095;</span>'
		],
		navElement: 'button type="button"',
		margin:10,
		autoplay:true,
		autoplayTimeout:10000,
		autoplayHoverPause:true,
		// animateOut: 'fadeOut',
        animateIn: 'fadeIn',
		responsive:{
			0:{
				items:1,
				dots:false,
                autoHeight: true,
                autoHeightClass: 'owl-height'
			},
			768:{
				dots:false,
			}
		}
    }); 
	jQuery("#HeroSlider").owlCarousel({
		navigation : true,
		items:1,
		margin:0,
		loop:true,
		nav:true,
		navText: [
			'<span aria-hidden="true">&#10094;</span>',
			'<span aria-hidden="true">&#10095;</span>'
		],
		navElement: 'button type="button"',
		autoplay:true,
		autoplayTimeout:5000,
		autoplayHoverPause:true
    });
	
	jQuery("#HeroSlider .owl-prev").attr("aria-label", "Previous slide");
	jQuery("#HeroSlider .owl-next").attr("aria-label", "Next slide");

    jQuery("#logosSlider").owlCarousel({
		navigation : true,
		items:7,
		loop:false,
		dots:false,
		nav:false,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:2,
				dots:true,
				dots:false,
			},
			575:{
				dots:false,
				items:3,
			},
			830:{
				dots:false,
				items:4,
			},
			992:{
				dots:false,
				items:5,
			},
			1200:{
				dots:false,
				items:7,
			}
		}
    });
	jQuery(".ProductsSlider").owlCarousel({
		navigation : true,
		margin:20,
		items:5,
		loop:true,
		dots:false,
		nav:true,
		navText: [
			'<span aria-hidden="true">&#10094;</span>',
			'<span aria-hidden="true">&#10095;</span>'
		],
		navElement: 'button type="button"',
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:2,
				dots:true,
			},
			575:{
				items:3,
                dots:true,
			},
			960:{
				dots:false,
				items:4,
			},
            1200:{
				dots:false,
				items:5,
			},
			1441:{
				dots:false,
				items:6,
			}
		}
    });
	jQuery("#BlogsSlider").owlCarousel({
		navigation : true,
		margin:20,
		items:5,
		loop:true,
		dots:false,
		nav:true,
		navText: [
			'<span aria-hidden="true">&#10094;</span>',
			'<span aria-hidden="true">&#10095;</span>'
		],
		navElement: 'button type="button"',
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1.5,
				dots:true,
				dots:false,
			},
			575:{
				dots:false,
				items:2,
			},
			992:{
				dots:false,
				items:3,
			},
			1200:{
				dots:false,
				items:4,
			},
			1537:{
				dots:false,
				items:5,
			}
		}
    });
    jQuery('#niateathree_slide').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 5000,
          arrows: true,
          responsive: [
            {
              breakpoint: 572,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
	jQuery("#ProductSlider").owlCarousel({
		navigation : true,
		items:3,
		margin:0,
		dots:true,
		loop:false,
		nav:true,
		navText: [
			'<span aria-hidden="true">&#10094;</span>',
			'<span aria-hidden="true">&#10095;</span>'
		],
		navElement: 'button type="button"',
		autoplay:true,
		autoplayTimeout:5000,
		autoplayHoverPause:true,
		responsive:{
			0:{
				items:2,
				dots:true,
			},
			640:{
				dots:true,
			}
		}
    });
	jQuery("#ReviewsSlider").owlCarousel({
		navigation : true,
		items:4,
		margin:20,
		loop:true,
		dots:false,
		nav:true,
		navText: [
			'<span aria-hidden="true">&#10094;</span>',
			'<span aria-hidden="true">&#10095;</span>'
		],
		navElement: 'button type="button"',
		autoplay:true,
		autoplayTimeout:5000,
		autoplayHoverPause:true
    });
	jQuery("#BlendSlider").owlCarousel({
		navigation : true,
		items:1,
		loop:true,
		dots:false,
		nav:true,
		navText: [
			'<span aria-hidden="true">&#10094;</span>',
			'<span aria-hidden="true">&#10095;</span>'
		],
		navElement: 'button type="button"',
		autoplay:false,
		autoplayTimeout:5000,
		autoplayHoverPause:true
    });

	// jQuery("#pdp-images-nav-slider").owlCarousel({
	// 	navigation : true,
	// 	items:4,
	// 	loop:false,
	// 	dots:false,
	// 	nav:true,
	// 	autoplay:false,
	// 	autoplayTimeout:3000,
	// 	autoplayHoverPause:true
    // });

	// init Isotope
	var $grid = jQuery('.reviews-products-wrap').isotope({
		itemSelector: '.reviewed-product-item',
        percentPosition: false,
		masonry: {
            columnWidth: '.reviewed-product-sizer',
            // horizontalOrder: false
        },
	  });

	 jQuery('#pdp-images-main-slider').slick({
        dots:false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '#pdp-images-nav-slider',
		infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots:true
            },
          }
        ]
    }); 
	jQuery('#pdp-images-nav-slider').slick({
  		arrows: false,
  		infinite: false,
  		dots:false,
  		slidesToShow: 3,
  		slidesToScroll: 1,
  		asNavFor: '#pdp-images-main-slider',
  		vertical: true,
        verticalScrolling: true,
  		focusOnSelect: true
	}); 


    jQuery("#Offer-Popup").owlCarousel({
		navigation : true,
		margin:20,
		items:3,
		loop:false,
		dots:false,
		nav:false,
		autoplay:false,
		autoplayTimeout:5000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1.7,
				dots:true,
                loop:true
			},
			992:{
				items:2, 
                dots:true
              
			},
			1200:{
				items:3,
                dots:false
            }
		}
    });
  


	
	jQuery("#RelatedProductSlider").owlCarousel({
		navigation : false,
		items:4,
		margin:20,
		loop:true,
		dots:true,
		nav:false,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true
    });
	jQuery('#shop-menu-btn').on('click', function(){
		jQuery(".side-menu").removeClass('menu-isClosed').addClass('menu-isOpen');
		jQuery("body").addClass('side-menu-open');
		setTimeout(() => {
			jQuery(".shop-dropdown-menu .menu-lavel-1").slideDown();
			jQuery(".shop-dropdown-menu > .sub-menu-item").find('#menu-accordion-icon').text(function(i, text){
				return text === "+" ? "-" : "+";
			});
		}, 300);
	});

	jQuery('#discover-menu-btn').on('click', function(){
		jQuery(".side-menu").removeClass('menu-isClosed').addClass('menu-isOpen');
		jQuery("body").addClass('side-menu-open');
		setTimeout(() => {
			jQuery(".discover-dropdown-menu .menu-lavel-1").slideDown();
			jQuery(".discover-dropdown-menu > .sub-menu-item").find('#menu-accordion-icon').text(function(i, text){
				return text === "+" ? "-" : "+";
			});
		}, 300);
	});

	jQuery('#BurgerMenu').on('click', function(){
		jQuery(".side-menu").removeClass('menu-isClosed').addClass('menu-isOpen');
		jQuery("body").addClass('side-menu-open');
	});
	jQuery('.side-menu-close').on('click', function(){
		jQuery(".side-menu").removeClass('menu-isOpen').addClass('menu-isClosed');
		jQuery("body").removeClass('side-menu-open');
	});

    jQuery('.overlay').on('click', function(){
		jQuery(".side-menu").removeClass('menu-isOpen').addClass('menu-isClosed');
        jQuery(".cart-side-menu").removeClass('cart-menu-isOpen').addClass('cart-menu-isClosed');
		jQuery("body").removeClass('side-menu-open');
	});
  

	jQuery('ul.menu-lavel-0 > li > .sub-menu-item').on('click', function(){
		jQuery(this).parent().find('ul.menu-lavel-1').slideToggle();
		jQuery(this).find('#menu-accordion-icon').text(function(i, text){
			return text === "+" ? "-" : "+";
		});
	});
	jQuery('ul.menu-lavel-1 > li > .sub-menu-item').on('click', function(){
		jQuery(this).parent().find('ul.menu-lavel-2').slideToggle();
		jQuery(this).find('#menu-accordion-icon').text(function(i, text){
			return text === "+" ? "-" : "+";
		})
	});
	jQuery('ul.menu-lavel-1 > li > .sub-menu-item-2').on('click', function(){
		jQuery(this).parent().find('ul.menu-lavel-2').slideToggle();
		jQuery(this).find('#menu-accordion-icon').text(function(i, text){
			return text === "+" ? "-" : "+";
		})
	});
  
  //   jQuery(document).on("click", function(e) {
  //     if (jQuery(e.target).is(".filter-menu-isOpen") === false) {
  //       jQuery(".product-filters-sidebar").removeClass('filter-menu-isOpen').addClass('filter-menu-isClosed');
		// jQuery("body").removeClass('side-menu-open');
  //     }
  //   });
    jQuery('#OpenFilter').on('click', function(){
		jQuery(".product-filters-sidebar").removeClass('filter-menu-isClosed').addClass('filter-menu-isOpen');
		jQuery("body").addClass('side-menu-open');
	});
    
	jQuery('#CloseFilter').on('click', function(){
		jQuery(".product-filters-sidebar").removeClass('filter-menu-isOpen').addClass('filter-menu-isClosed');
		jQuery("body").removeClass('side-menu-open');
	});

	
	jQuery('#CartMenu').on('click', function(){
		jQuery(".cart-side-menu").removeClass('cart-menu-isClosed').addClass('cart-menu-isOpen');
		jQuery("body").addClass('side-menu-open');
	});
	jQuery('.cart-side-menu-close').on('click', function(){
		jQuery(".cart-side-menu").removeClass('cart-menu-isOpen').addClass('cart-menu-isClosed');
		jQuery("body").removeClass('side-menu-open');
	});
	jQuery('#CartMenu').on('click', function(){
		jQuery(".cart-side-menu").removeClass('cart-menu-isClosed').addClass('cart-menu-isOpen');
		jQuery("body").addClass('side-menu-open');
	});

    jQuery('.recover-password').on('click', function(){
		jQuery("#forgot-form").show();
        jQuery("#login-form").hide();
	});

   jQuery('.back-login').on('click', function(){
		jQuery("#forgot-form").hide();
        jQuery("#login-form").show();
	});


  

	jQuery('#moreless-button').on('click' , function() {
		jQuery('.moretext').slideToggle();
		if (jQuery('#moreless-button').text() == "Read More ↓") {
			jQuery(this).text("Read Less ↑")
		} else {
			jQuery(this).text("Read More ↓")
		}
	  });
	  jQuery('#moreless-button-second').on('click' , function() {
		jQuery('.moretext-second').slideToggle();
		if (jQuery('#moreless-button-second').text() == "Read More ↓") {
			jQuery(this).text("Read Less ↑")
		} else {
			jQuery(this).text("Read More ↓")
		}
	  });
	  jQuery('#moreless-button-third').on('click' , function() {
		jQuery('.moretext-third').slideToggle();
		if (jQuery('#moreless-button-third').text() == "Read More ↓") {
			jQuery(this).text("Read Less ↑")
		} else {
			jQuery(this).text("Read More ↓")
		}
	  });

  //sticky-header
  
  jQuery(window).scroll(function(){
    var sticky = jQuery('#shopify-section-header'),
        scroll = jQuery(window).scrollTop();

    var sticky2 = jQuery('.header-menu-wrapper');
    
  
        if (scroll >= 200) sticky.addClass('nav-fixed');
        else sticky.removeClass('nav-fixed');

       if (scroll >= 200) sticky2.addClass('nav-fixed');
        else sticky2.removeClass('nav-fixed');
  });


  jQuery(document).delegate(".__notify-me", "click", function(e) {
    if(jQuery(this).data("title")!="undefined" && jQuery(this).data("product-id")!="undefined" && jQuery(this).data("variant-id")!="undefined"){
      jQuery('#notify-modal h3').text(jQuery(this).data("title"));
      jQuery('#notify-modal #product').val(jQuery(this).data("product-id"));
      jQuery('#notify-modal #variant').val(jQuery(this).data("variant-id"));
      jQuery('#notify-modal').modal('show');
    }
      
  });

  jQuery(document).delegate("#notify-modal .btn-close", "click", function(e) {
   jQuery('#notify-modal').modal('hide');
  });
  function validateEmail($email) {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      return emailReg.test( $email );
    }


   jQuery(document).on('click', '#notify-me-submit', function(e){
       var email_input = jQuery('#notify-modal input[id="email"]').val();
       var product_input = jQuery('#notify-modal input[id="product"]').val();
       var variant_input = jQuery('#notify-modal input[id="variant"]').val();
       e.preventDefault();

      if(email_input=='undefined' || email_input==''){
        jQuery('#notify-modal .error').show();
        return;
      }
      if(!validateEmail(email_input)) { 
        jQuery('#notify-modal .error').show();
        return;
      }

     if(email_input!=='undefined' && product_input!=='undefined' && variant_input!=='undefined'){
        jQuery('#notify-modal .error').hide();
        jQuery('#notify-modal .__loading').show();
       
        jQuery.ajax({
         url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
         type: "post",
         data: {
              a:"QjAjin",
              email: email_input,
              variant: variant_input,
              product: product_input,
              platform: "shopify",
              subscribe_for_newsletter:true,
              g: "TU6JCd"
           },
         success: function (response) {
              jQuery('#notify-modal .__loading').hide();
              jQuery('#notify-modal .notify-me-form').hide();
              jQuery('#notify-modal .success').show();
              return;
         },
          error: function() {
            jQuery('#notify-modal .__loading').hide();
            jQuery('#notify-modal .tryagain').show();
            return;
          }
        });
      }
     
     
   });


 // jQuery(document).delegate("#gcms_result", "click", function(e) {
 //      var batch_input = jQuery('input[id="batch-number"]').val();
 //      if(batch_input=='undefined' || batch_input==''){
 //        jQuery('.input-batch-number .error').text('Please enter the Batch Number!');
 //        jQuery('.input-batch-number .error').show();
 //        return;
 //      }

 //     if(batch_input!=='undefined'){
 //       jQuery('.input-batch-number .error').hide();
 //       jQuery('.input-batch-number .error').text('GCMS lookup is currently having issues, please contact customer service for your report');
 //       jQuery('#gcms_result').hide();
 //       jQuery('.input-batch-number .error').show();
 //       // jQuery.ajax({
 //       //   url: "https://api.rockymountainoils.com/api/look-up?b="+batch_input,
 //       //   type: "get",
 //       //   success: function (response) {
 //       //        if(response['status']==200){
 //       //          jQuery('#GCMS-Result').show();
 //       //          jQuery('#GCMS-Result h2 span').text(response['product_title']);
 //       //          jQuery('#GCMS-Result .result-info h3').text(response['batch']);
 //       //          jQuery('#GCMS-Result .result-html-table').html(response['result']);
 //       //          jQuery('#GCMS-Result .result-html').show();
                
 //       //        } else {
 //       //          jQuery('#GCMS-Result .result-html').hide();
 //       //          jQuery('#GCMS-Result').show();
 //       //          jQuery('#GCMS-Result h2 span').html('No Result');
                
 //       //        }
 //       //        return;
 //       //   },
 //       //    error: function() {
 //       //      jQuery('.input-batch-number .error').text('GCMS lookup is currently having issues, please contact customer service for your report');
 //       //      jQuery('#gcms_result').hide();
 //       //      jQuery('.input-batch-number .error').show();
 //       //      return;
 //       //    }
 //       //  });

       
 //     }
 //  });

    // var maxLength = 200;
    // jQuery(".collections-description-text").each(function(){
    //  var myStr = jQuery(this).text();
    //  if(jQuery.trim(myStr).length < maxLength){
    //   jQuery('span#ReadMore').remove();
    //  }else{
    //    jQuery(this).addClass('More');
    //  }
    // });

    // jQuery('span#ReadMore').on('click',function(){
    //     jQuery('.collections-description-text').css('max-height','initial');
    //     jQuery(this).hide();
    // });	


    jQuery(".read_more").click(function() {
        jQuery('html, body').animate({
            scrollTop: jQuery(".__description").offset().top - 100
        }, 500);
    });


   // faq
    
    jQuery('.faq-question').on('click', function(){
      jQuery('.faq-answer').removeClass('active');
    //jQuery(this).parent().addClass('active');
      jQuery(this).parent().toggleClass("active");
  
      jQuery(this).next().slideToggle();
      jQuery(this).parent().siblings().removeClass('active');
      jQuery(this).parent().siblings().find('.faq-answer').slideUp('active');
    });



  // Donation

  jQuery('.donation-option ul li').on('click', function(){
      jQuery('.donation-option ul li').removeClass('active');
      jQuery(this).toggleClass("active");
      var value = jQuery(this).data("value");
      if(value == 'custom'){
        jQuery('.donation-custom').show();
      } else {
        jQuery('.donation-custom').hide();
        jQuery('#quantity').val(value);
      }
  
    });


  jQuery(".combined").click(function() {
        jQuery('html, body').animate({
            scrollTop: jQuery(".special-promotion").offset().top - 120
        }, 500);
    });

    
	
 
});